<template>
	<div class="main">
		<div class="top_navbar">
			<div class="top_left">
				<div class="navbar" v-for="(item, index) in navbarList" :key='index' @click="topNavBtn(index)"
					:class="{'top_active':topNavIndex==index}">
					<router-link :to="{ name: item.routeName }"><img :src="item.imgUrl" />
						{{item.name}}
					</router-link>
				</div>
			</div>
			<div class="right_out">
				<img src="../assets/image/vehicleHomeTopBtn.png" />
			</div>
		</div>
		<div class="left_navbar">
			<div class="left_navbar_logo">
				无线谷5G靶向车
				<p>运行监测平台</p>
			</div>
			<div class="navbar_box" :class="{'left_active':leftNavIndex==index}"
				v-for="(item, index) in navbarList[topNavIndex].navList" :key='index' @click="leftNavIndex=index">
				<router-link :to="item.base + item.href">
					<img :src="item.imgUrl" />
					{{item.name}}
				</router-link>
			</div>
		</div>
		<div class="content">
			<router-view />
		</div>
	</div>
</template>

<script>
	import LeftNavigation from "../components/LeftNavigation";
	export default {
		name: "Platform",
		data() {
			return {
				navbarList: [{
						name: '平台首页',
						imgUrl: require('../assets/image/vehicleHomeList1.png'),
						routeName: 'VehicleHome'
					},
					{
						name: '车辆管理',
						imgUrl: require('../assets/image/vehicleHomeList2.png'),
						routeName: 'Navigation',
						navList: [{
								base: "/Navigation",
								href: "/vehicleState",
								imgUrl: require('../assets/image/navbar1.png'),
								name: "车辆状态"
							},
							{
								base: "/Navigation",
								href: "/vehicleSite",
								imgUrl: require('../assets/image/navbar2.png'),
								name: "停靠点管理"
							},
							{
								base: "/Navigation",
								href: "/vehicleRoute",
								imgUrl: require('../assets/image/navbar4.png'),
								name: "路线管理"
							},
							{
								base: "/Navigation",
								href: "/vehicleTrigger",
								imgUrl: require('../assets/image/navbar4.png'),
								name: "触发型任务"
							},
							{
								base: "/Navigation",
								href: "/vehicleTask",
								imgUrl: require('../assets/image/navbar3.png'),
								name: "任务调度"
							},
							{
								base: "/Navigation",
								href: "/vehicleHistorical",
								imgUrl: require('../assets/image/navbar3.png'),
								name: "历史任务"
							},
						]
					},
					{
						name: '气象监测',
						imgUrl: require('../assets/image/vehicleHomeList3.png'),
						routeName: 'Environment',
						navList: [{
								base: "/Environment",
								href: "/environment",
								imgUrl: require('../assets/image/navbar1.png'),
								name: "监测首页"
							},
							{
								base: "/Environment",
								href: "/environmentSite",
								imgUrl: require('../assets/image/navbar2.png'),
								name: "站点管理"
							},
							{
								base: "/Environment",
								href: "/environmentData",
								imgUrl: require('../assets/image/navbar3.png'),
								name: "数据查询"
							}
						]
					},
					{
						name: '气体监测',
						imgUrl: require('../assets/image/vehicleHomeList4.png'),
						routeName: 'Gas',
						navList: [{
								base: "/Gas",
								href: "/gas",
								imgUrl: require('../assets/image/navbar1.png'),
								name: "监测首页"
							},
							{
								base: "/Gas",
								href: "/gasSite",
								imgUrl: require('../assets/image/navbar2.png'),
								name: "站点管理"
							},
							{
								base: "/Gas",
								href: "/gasData",
								imgUrl: require('../assets/image/navbar3.png'),
								name: "数据查询"
							}
						]
					},
					{
						name: '水质监测',
						imgUrl: require('../assets/image/vehicleHomeList7.png'),
						routeName: 'WaterQuality',
						navList: [{
								base: "/WaterQuality",
								href: "/waterQuality",
								imgUrl: require('../assets/image/navbar1.png'),
								name: "监测首页"
							},
							{
								base: "/WaterQuality",
								href: "/waterQualitySite",
								imgUrl: require('../assets/image/navbar2.png'),
								name: "站点管理"
							},
							{
								base: "/WaterQuality",
								href: "/waterQualityData",
								imgUrl: require('../assets/image/navbar3.png'),
								name: "数据查询"
							}
						]
					},
					{
						name: '视频监控',
						imgUrl: require('../assets/image/vehicleHomeList5.png'),
						routeName: 'Video',
						navList: [{
								base: "/Video",
								href: "/videomonitor",
								imgUrl: require('../assets/image/51.png'),
								name: "实时监控"
							},
							{
								base: "/Video",
								href: "/videospare",
								imgUrl: require('../assets/image/50.png'),
								name: "视频回放"
							},
						]
					},
					{
						name: '平台告警',
						imgUrl: require('../assets/image/vehicleHomeList6.png'),
						routeName: 'Platformalarm',
						navList: [
							{
								base: "/Platformalarm",
								href: "/messagepush",
								imgUrl: require('../assets/image/消息推送.png'),
								name: "设备日志"
							},
							{
								base: "/Platformalarm",
								href: "/alarmrecord",
								imgUrl: require('../assets/image/报警记录.png'),
								name: "报警记录"
							},
						]
					},
					{
						name: '历史热图',
						imgUrl: require('../assets/image/vehicleHomeList8.png'),
						routeName: 'HistoryMap',
						navList: [
							{
								base: "/HistoryMap",
								href: "/historyMap",
								imgUrl: require('../assets/image/消息推送.png'),
								name: "历史热图"
							},
							{
								base: "/HistoryMap",
								href: "/automatic",
								imgUrl: require('../assets/image/50.png'),
								name: "播放热图"
							},
						]
					},
				],
				topNavIndex: 1, //顶部导航切换索引
				leftNavIndex: 0, //左边导航切换索引
			};
		},
		components: {
			LeftNavigation
		},
		created() {
			if (this.$route.name == 'vehicleState') {
				this.topNavIndex = 1
			} else if (this.$route.name == 'environment') {
				this.topNavIndex = 2
			} else if (this.$route.name == 'gas') {
				this.topNavIndex = 3
			} else if (this.$route.name == 'waterQuality') {
				this.topNavIndex = 4
			} else if (this.$route.name == 'videomonitor') {
				this.topNavIndex = 5
			} else if (this.$route.name == 'messagepush') {
				this.topNavIndex = 6
			} else if (this.$route.name == 'historyMap') {
				this.topNavIndex = 7
			}
		},
		methods: {
			topNavBtn(index) {
				this.topNavIndex = index
				this.leftNavIndex = 0
			},
			clcikNavbar(e) {
				console.log(e)
			},
		}
	};
</script>

<style>
	body {
		background-color: #F5F5F5;
	}

	.top_navbar {
		position: fixed;
		top: 0;
		left: 12%;
		display: flex;
		width: 88%;
		padding: 14px 0;
		background-color: #fff;
		box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.16);
		z-index: 20;
	}

	.top_navbar .top_left {
		width: 90%;
		display: flex;
		justify-content: space-around;
		padding: 0 20px;
	}

	.top_navbar .right_out img {
		width: 40px;
		height: 40px;
		margin-top: 10px;
	}

	.top_navbar .top_left .navbar {
		display: inline-flex;
		line-height: 55px;
		box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
		border-radius: 14px;
	}

	.top_navbar .top_left .top_active {
		background-color: #7F86E9;
	}

	.main .top_navbar .top_left .top_active a {
		color: #fff;
	}

	.top_navbar .top_left .navbar a {
		padding: 0 20px 0 12px;
		color: #666666;
		font-size: 14px;
	}

	.top_navbar .top_left .navbar img {
		width: 35px;
		height: 35px;
		float: left;
		margin-top: 10px;
		margin-right: 10px;
	}

	.left_navbar {
		position: fixed;
		left: 0;
		top: 0;
		width: 12%;
		height: 100%;
		background: url(../assets/image/leftNavbar.png) 30%;
	}

	.left_navbar .left_navbar_logo {
		padding: 15px 0 20px 30px;
		font-size: 14px;
		font-family: Source Han Sans CN;
		color: #fff;
	}

	.left_navbar .left_navbar_logo p {
		font-size: 18px;
		padding-top: 2px;
		margin-bottom: 0;
	}

	.left_navbar .navbar_box a {
		line-height: 52px;
		color: #fff;
		padding-left: 30px;
		font-size: 14px;
	}

	.left_navbar .navbar_box img {
		width: 14px;
		height: 14px;
		margin-right: 10px;
	}

	.left_navbar .left_active {
		background-color: #454E8D;
	}

	.content {
		margin-top: 84px;
		margin-left: 12%;
		padding: 16px 40px 25px 26px;
		background-color: #F5F5F5;
	}

	@media screen and (max-width: 1500px) {}

	@media screen and (max-width: 1350px) {}
</style>
